import { h, Component, createRef, Fragment } from 'preact';

import './index.less';
import RequestIdentityChatBubble from '../../organisms/RequestIdentityChatBubble';

import EventBus from '../../lib/EventBus';

import { animate } from '../../lib/Animation';
import { addClass, removeClass } from '../../lib/Dom';
import I18n from '../../lib/I18n';
import { getCompanyId, getCompanyName } from '../../lib/Company';
import { getIdentity, setIdentity, validatePhone } from '../../lib/Identity';
import { shouldVerifyOTP, sendOTP, resendOTP, generateNonce, validateOtp } from '../../lib/Otp';
import { cdnHost, reCaptchaSiteKey } from '../../../config';
import { getCountries } from '../../lib/Country';
import { createOrGetVisitor } from '../../lib/Visitor';
import { getCatalogueTheme } from '../../lib/Theme';
import SendButton from '../../molecules/Icon/SendButton';
import OTPError from '../../organisms/OTPError';
import { MK_JEWELLERS_COMPANY_ID, OTP_TYPES } from '../../../../utils/constants';
import ReCAPTCHA from 'react-google-recaptcha';
import sha256 from 'crypto-js/sha256';
import Timer from '../../molecules/Timer';
import { getDomainTag } from '../../lib/Amalgam';

class RequestIdentityChat extends Component {
  constructor (props) {
    super(props);

    this.recaptchaRef = createRef();

    this.INITIAL_STATE = {
      messages: [],
      inputType: null,
      customerName: '',
      nationalNumber: '',
      selectedCountry: this.getCountryFromCountryCode('IN'),
      otpCode: '',
      error: null,
      showOtpTimer: true
    };

    this.MESSAGE_TYPE = {
      SELF: 'SELF',
      OTHER: 'OTHER'
    };

    this.INPUT_TYPE = {
      NAME: 'NAME',
      PHONE: 'PHONE',
      OTP: 'OTP',
      PHONE_ENTERED: 'PHONE_ENTERED',
      OTP_ENTERED: 'OTP_ENTERED'
    };

    this.e164Number = '';
    this.otpSent = false;
    this.onDone = () => {};
    this.isMounted = false;

    this.state = this.INITIAL_STATE;
  }

  componentDidMount () {
    this.isMounted = true;

    const domainTag = getDomainTag() || {};
    const { qs_customer_name: customerName, qs_phone_number: nationalNumber } = domainTag;
    this.setState({ customerName, nationalNumber });

    EventBus.addListener(EventBus.TYPE.SHOW_REQUEST_IDENTITY_CHAT, this.show);
    EventBus.addListener(EventBus.TYPE.HIDE_REQUEST_IDENTITY_MODAL, this.hide);

    this.selectDefaultCountry();

    getIdentity().then((identity) => {
      if (identity.phone) {
        this.e164Number = identity.phone;
      }
    });
  }

  componentWillUnmount () {
    this.isMounted = false;

    EventBus.removeListener(EventBus.TYPE.SHOW_REQUEST_IDENTITY_CHAT, this.show);
    EventBus.removeListener(EventBus.TYPE.HIDE_REQUEST_IDENTITY_MODAL, this.hide);
    removeClass(document.querySelector('body'), 'block-scroll');
    removeClass(document.querySelector('html'), 'block-scroll');
  }

  selectDefaultCountry = () => {
    createOrGetVisitor()
      .then((visitor) => (visitor ? visitor.getCountryCode() : null))
      .then((countryCode) => {
        if (countryCode) {
          this.setState({
            selectedCountry: this.getCountryFromCountryCode(countryCode)
          });
        }
      });
  };

  getCountryFromCountryCode = (countryCode) => {
    const countries = getCountries();

    for (let i = 0; i < countries.length; i += 1) {
      if (countries[i].countryCode === countryCode) {
        return countries[i];
      }
    }

    return {};
  };

  show = ({ onDone }) => {
    this.onDone = onDone || (() => {});

    this.container.style.display = 'block';
    animate(this.container, 0.3, { opacity: 1 }, () => {
      addClass(document.querySelector('body'), 'block-scroll');
      addClass(document.querySelector('html'), 'block-scroll');

      this.proceed();
    });
  };

  hide = () => {
    const domainTag = getDomainTag() || {};
    const { qs_customer_name: customerName, qs_phone_number: nationalNumber } = domainTag;
    this.setState(
      { ...this.INITIAL_STATE, customerName, nationalNumber },
      this.selectDefaultCountry
    );
  };

  proceed = async (otpType, isResend) => {
    getIdentity()
      .then(async (identity) => {
        if (!this.isMounted) {
          return;
        }

        const name = identity.name ? identity.name.trim() : '';
        const phone = identity.phone ? identity.phone.trim() : '';
        const phoneVerified = identity.phoneVerified !== undefined ? identity.phoneVerified : false;

        if (!name) {
          this.addMessage({
            name: getCompanyName(),
            message: I18n.t('REQUEST_IDENTITY_CHAT_INTENT_VERIFY'),
            type: this.MESSAGE_TYPE.OTHER
          });

          setTimeout(() => {
            if (!this.isMounted) {
              return;
            }

            this.addMessage(
              {
                name: getCompanyName(),
                message: I18n.t('REQUEST_IDENTITY_CHAT_ENTER_NAME'),
                type: this.MESSAGE_TYPE.OTHER
              },
              this.INPUT_TYPE.NAME
            );
          }, 1000);

          return;
        }

        if (!phone) {
          this.addMessage(
            {
              name: getCompanyName(),
              message: I18n.t('REQUEST_IDENTITY_CHAT_ENTER_PHONE'),
              type: this.MESSAGE_TYPE.OTHER
            },
            this.INPUT_TYPE.PHONE
          );

          return;
        }
        this.e164Number = phone;

        if (shouldVerifyOTP() && !phoneVerified) {
          if (!this.otpSent) {
            this.setState({ error: null });
            try {
              const companyId = getCompanyId();
              const deviceToken =
                companyId === MK_JEWELLERS_COMPANY_ID
                  ? 'mk_jewellers'
                  : await this.recaptchaRef.current.executeAsync();
              const currentTimeStamp = new Date().toISOString();
              const resp = await generateNonce(
                currentTimeStamp,
                deviceToken,
                isResend ? otpType : OTP_TYPES.SMS.value,
                'CATALOGUE'
              );
              const nonce = sha256(resp.nonce + currentTimeStamp).toString();
              if (isResend) {
                await resendOTP(
                  phone,
                  this.state.selectedCountry.countryCode,
                  deviceToken,
                  otpType,
                  'CATALOGUE',
                  nonce
                );
              } else {
                await sendOTP(
                  phone,
                  this.state.selectedCountry.countryCode,
                  deviceToken,
                  OTP_TYPES.SMS.value,
                  'CATALOGUE',
                  nonce
                );
              }
              this.otpSent = true;
            } catch (error) {
              this.setState({ error });
            } finally {
              if (
                !!this.recaptchaRef.current &&
                typeof this.recaptchaRef.current.reset === 'function'
              ) {
                this.recaptchaRef.current.reset();
              }
            }
          }

          this.addMessage(
            {
              name: getCompanyName(),
              message: I18n.t('REQUEST_IDENTITY_CHAT_ENTER_OTP', { phone }),
              type: this.MESSAGE_TYPE.OTHER
            },
            this.INPUT_TYPE.OTP
          );

          return;
        }

        this.addMessage(
          {
            name: getCompanyName(),
            message: I18n.t('REQUEST_IDENTITY_CHAT_THANKS'),
            type: this.MESSAGE_TYPE.OTHER
          },
          null
        );

        setTimeout(() => {
          this.onClose();
        }, 1000);
      })
      .catch(() => {});
  };

  scrollToBottom = () => {
    this.chatContainer.scrollTop += 400;
  };

  addMessage = (message, inputType = null) => {
    const prevMessages = [...this.state.messages];
    const lastMessage = prevMessages[prevMessages.length - 1];

    if (lastMessage && lastMessage.removable) {
      prevMessages.pop();
    }

    this.setState({ messages: [...prevMessages, message], inputType }, () => {
      this.scrollToBottom();
    });
  };

  showWaitMessage = () => {
    this.addMessage({
      name: getCompanyName(),
      message: I18n.t('REQUEST_IDENTITY_CHAT_VERIFY_OTP_WAIT'),
      removable: true,
      type: this.MESSAGE_TYPE.OTHER
    });
  };

  acceptInput = async (
    inputType,
    { name, phone, otp },
    otpType = OTP_TYPES.WHATSAPP.value,
    isResend,
    deviceToken
  ) => {
    let promise = null;
    if (inputType === this.INPUT_TYPE.NAME) {
      promise = setIdentity({ name });
    } else if (inputType === this.INPUT_TYPE.PHONE) {
      promise = setIdentity({ phone, phoneVerified: false }).then(async () => {
        if (!shouldVerifyOTP()) {
          return Promise.resolve();
        }
        this.setState({ error: null });
        return new Promise((resolve) => {
          const currentTimeStamp = new Date().toISOString();
          generateNonce(currentTimeStamp, deviceToken, otpType, 'CATALOGUE')
            .then((response) => {
              const nonce = sha256(response.nonce + currentTimeStamp).toString();
              return sendOTP(
                phone,
                this.state.selectedCountry.countryCode,
                deviceToken,
                otpType,
                'CATALOGUE',
                nonce
              ).then(() => {
                this.otpSent = true;
                resolve();
              });
            })
            .catch((error) => {
              this.addMessage({
                name: getCompanyName(),
                message: I18n.t('REQUEST_IDENTITY_CHAT_SMS_FAIL'),
                type: this.MESSAGE_TYPE.OTHER
              });
              this.setState({ error });
              resolve();
            })
            .finally(() => {
              if (
                !!this.recaptchaRef.current &&
                typeof this.recaptchaRef.current.reset === 'function'
              ) {
                this.recaptchaRef.current.reset();
              }
              resolve();
            });
        });
      });
    } else if (inputType === this.INPUT_TYPE.OTP) {
      if (isResend) {
        promise = new Promise((resolve) => {
          this.setState({ error: null });

          const currentTimeStamp = new Date().toISOString();

          generateNonce(currentTimeStamp, deviceToken, otpType, 'CATALOGUE')
            .then((response) => {
              const nonce = sha256(response.nonce + currentTimeStamp).toString();
              return resendOTP(
                phone,
                this.state.selectedCountry.countryCode,
                deviceToken,
                otpType,
                'CATALOGUE',
                nonce
              );
            })
            .then(() => {
              this.otpSent = true;
              resolve();
            })
            .catch((error) => {
              this.addMessage({
                name: getCompanyName(),
                message: I18n.t('REQUEST_IDENTITY_CHAT_SMS_FAIL'),
                type: this.MESSAGE_TYPE.OTHER
              });
              this.setState({ error });
              resolve();
            })
            .finally(() => {
              if (
                this.recaptchaRef.current &&
                typeof this.recaptchaRef.current.reset === 'function'
              ) {
                this.recaptchaRef.current.reset();
              }
              resolve();
            });
        });
      } else {
        promise = new Promise((resolve) => {
          validateOtp(otp, phone)
            .then((response) => {
              if (!response.verified) {
                setTimeout(() => {
                  this.addMessage(
                    {
                      name: getCompanyName(),
                      message: I18n.t('REQUEST_IDENTITY_CHAT_INVALID_OTP'),
                      type: this.MESSAGE_TYPE.OTHER
                    },
                    this.INPUT_TYPE.OTP
                  );
                }, 100);
              } else {
                setIdentity({ phone, phoneVerified: true }).then(() => {});
              }
              window.e164PhoneVerified = true;
              resolve();
            })
            .catch((error) => {
              setTimeout(() => {
                this.addMessage(
                  {
                    name: getCompanyName(),
                    message: I18n.t('REQUEST_IDENTITY_CHAT_INVALID_OTP'),
                    type: this.MESSAGE_TYPE.OTHER
                  },
                  this.INPUT_TYPE.OTP
                );
              }, 100);
              resolve();
            })
            .finally(() => {
              if (
                !!this.recaptchaRef.current &&
                typeof this.recaptchaRef.current.reset === 'function'
              ) {
                this.recaptchaRef.current.reset();
              }
              resolve();
            });
        });
      }
    }

    if (promise) {
      promise.then(() => {
        setTimeout(() => {
          this.proceed(otpType, isResend);
        }, 550);
      });
    }
  };

  onClose = () => {
    removeClass(document.querySelector('body'), 'block-scroll');
    removeClass(document.querySelector('html'), 'block-scroll');

    animate(this.container, 0.3, { opacity: 0 }, () => {
      this.container.style.display = 'none';

      this.setState(this.INITIAL_STATE);
      this.onDone();
    });
  };

  onNameChange = (e) => {
    this.setState({ customerName: e.target.value });
  };

  onNameKeyUp = (e) => {
    if (e.keyCode === 13) {
      this.onNameSubmit();
    }
  };

  onNameSubmit = () => {
    let { customerName } = this.state;

    customerName = customerName ? customerName.trim() : customerName;

    if (!customerName) {
      return;
    }

    this.addMessage({
      name: '',
      message: customerName,
      type: this.MESSAGE_TYPE.SELF
    });

    this.acceptInput(this.INPUT_TYPE.NAME, { name: customerName });
  };

  onCountryChange = (e) => {
    this.setState({
      selectedCountry: JSON.parse(e.target.value),
      error: null
    });
  };

  onPhoneChange = (e) => {
    this.setState({ nationalNumber: e.target.value, error: null });
  };

  onPhoneKeyUp = (e) => {
    if (e.keyCode === 13) {
      this.onPhoneSubmit();
    }
  };

  onPhoneSubmit = async (otpType, isResend) => {
    this.setState({ error: null });

    const { nationalNumber: nationalNumberRaw, selectedCountry } = this.state;

    const nationalNumber = (nationalNumberRaw || '').trim().replace(/[ |-]/g, '');

    if (!nationalNumber && !this.e164Number) {
      return;
    }

    const callingCode = selectedCountry.callingCode.split(' ').join('');

    if (nationalNumber) {
      this.e164Number = callingCode + nationalNumber;
    }

    if (!isResend) {
      this.addMessage(
        {
          name: '',
          message: this.e164Number,
          type: this.MESSAGE_TYPE.SELF
        },
        this.INPUT_TYPE.PHONE_ENTERED
      );
    }
    if (isResend) {
      const companyId = getCompanyId();
      const deviceToken =
        companyId === MK_JEWELLERS_COMPANY_ID
          ? 'mk_jewellers'
          : await this.recaptchaRef.current.executeAsync();
      this.setState({
        showOtpTimer: true
      });
      this.acceptInput(
        this.INPUT_TYPE.OTP,
        { phone: this.e164Number },
        otpType,
        isResend,
        deviceToken
      );
      return;
    }

    setTimeout(this.showWaitMessage, 0);

    validatePhone(this.e164Number).then(async (result) => {
      const { e164Number: proper164Number, validated } = result;

      if (proper164Number && validated) {
        this.e164Number = proper164Number;
      }

      if (!validated) {
        this.addMessage(
          {
            name: getCompanyName(),
            message: I18n.t('REQUEST_IDENTITY_CHAT_INVALID_PHONE', {
              phone: this.e164Number
            }),
            type: this.MESSAGE_TYPE.OTHER
          },
          this.INPUT_TYPE.PHONE
        );

        return;
      }

      const companyId = getCompanyId();
      const deviceToken =
        companyId === MK_JEWELLERS_COMPANY_ID
          ? 'mk_jewellers'
          : await this.recaptchaRef.current.executeAsync();
      this.acceptInput(
        this.INPUT_TYPE.PHONE,
        { phone: this.e164Number },
        otpType,
        isResend,
        deviceToken
      );
    });
  };

  onOtpChange = (e) => {
    this.setState({ otpCode: e.target.value });
  };

  onOtpKeyUp = (e) => {
    if (e.keyCode === 13) {
      this.onOtpSubmit();
    }
  };

  onOtpSubmit = () => {
    const { otpCode } = this.state;

    if (!otpCode) {
      return;
    }

    this.addMessage(
      {
        name: '',
        message: otpCode,
        type: this.MESSAGE_TYPE.SELF
      },
      this.INPUT_TYPE.OTP_ENTERED
    );

    setTimeout(() => {
      this.showWaitMessage();
      this.acceptInput(this.INPUT_TYPE.OTP, {
        phone: this.e164Number,
        otp: otpCode
      });
    }, 500);
  };

  onChangeNumber = () => {
    this.setState({ error: null, otpCode: '' });
    this.addMessage(
      {
        name: getCompanyName(),
        message: I18n.t('REQUEST_IDENTITY_CHAT_ENTER_NEW_NUMBER'),
        type: this.MESSAGE_TYPE.OTHER
      },
      this.INPUT_TYPE.PHONE
    );
    if (!!this.recaptchaRef.current && typeof this.recaptchaRef.current.reset === 'function') {
      this.recaptchaRef.current.reset();
    }
  };

  render () {
    const {
      messages,
      inputType,
      customerName,
      nationalNumber,
      selectedCountry,
      otpCode,
      error,
      showOtpTimer
    } = this.state;

    const {
      homepage: { catalogueTitleColor, moreCatalogueBoxShadow, backgroundColor } = {},
      addToCartButton = {},
      themeTextColor = '#000000'
    } = getCatalogueTheme();

    return (
      <div ref={(element) => (this.container = element)} className="request-identity-chat">
        <div
          ref={(element) => (this.chatContainer = element)}
          style={{ backgroundColor }}
          className="chat-container"
        >
          <div className="messages-container">
            {messages.map((message) => (
              <RequestIdentityChatBubble
                MESSAGE_TYPE={this.MESSAGE_TYPE}
                name={message.name}
                message={message.message}
                type={message.type}
                messageBackgroundColor={backgroundColor}
                textColor={catalogueTitleColor}
                messageBoxShadow={moreCatalogueBoxShadow}
              />
            ))}
          </div>

          {inputType === this.INPUT_TYPE.NAME && (
            <div
              className="chat-input-box"
              style={{
                backgroundColor,
                border: `1px solid ${addToCartButton.backgroundColor}`
              }}
            >
              <div className="name-input" style={{ backgroundColor }}>
                <input
                  type="text"
                  placeholder={I18n.t('REQUEST_IDENTITY_CHAT_ENTER_NAME_PLACEHOLDER')}
                  className="name-input-text user-input"
                  value={customerName}
                  onInput={this.onNameChange}
                  onKeyUp={this.onNameKeyUp}
                  style={{
                    backgroundColor,
                    color: addToCartButton.color,
                    borderBottom: `2px solid ${addToCartButton.color}`
                  }}
                />
              </div>

              <div
                className="send-button-phone"
                style={{ ...addToCartButton, border: 'none' }}
                onClick={this.onNameSubmit}
              >
                <SendButton fill={addToCartButton.textColor} height={26} width={26} />
              </div>
            </div>
          )}

          {inputType === this.INPUT_TYPE.PHONE && (
            <div
              className="chat-input-box"
              style={{
                backgroundColor,
                border: `1px solid ${addToCartButton.backgroundColor}`
              }}
            >
              <div className="country" style={{ ...addToCartButton, border: 'none' }}>
                <div className="display">
                  <img
                    src={`${cdnHost}assets/flags/${selectedCountry.countryCode.toLowerCase()}.png`}
                    alt={`${selectedCountry.countryCode.toLowerCase()} flag`}
                    height={13}
                    width={20}
                  />
                  <span style={{ color: addToCartButton.textColor }}>
                    {selectedCountry.callingCode}
                  </span>
                </div>

                <select value={JSON.stringify(selectedCountry)} onChange={this.onCountryChange}>
                  {getCountries().map((country) => (
                    <option
                      value={JSON.stringify(country)}
                      label={country.name + ' (' + country.callingCode + ')'}
                    >
                      {country.name + ' (' + country.callingCode + ')'}
                    </option>
                  ))}
                </select>
              </div>

              <div className="phone-input" style={{ backgroundColor }}>
                <input
                  type="tel"
                  className="phone-input-text user-input"
                  value={nationalNumber}
                  onInput={this.onPhoneChange}
                  onKeyUp={this.onPhoneKeyUp}
                  style={{
                    color: addToCartButton.color,
                    borderBottom: `2px solid ${addToCartButton.color}`
                  }}
                />
              </div>

              <div
                className="send-button-phone"
                style={{ ...addToCartButton, border: 'none' }}
                onClick={() => {
                  this.onPhoneSubmit(OTP_TYPES.WHATSAPP.value, false);
                }}
              >
                <SendButton fill={addToCartButton.textColor} height={26} width={26} />
              </div>
            </div>
          )}

          {inputType === this.INPUT_TYPE.OTP && (
            <div
              className="chat-input-box"
              style={{
                backgroundColor,
                border: `1px solid ${addToCartButton.backgroundColor}`
              }}
            >
              <div className="otp-input">
                <label className="phone-input-label">{I18n.t('OTP_CODE')}</label>
                <input
                  type="tel"
                  className="phone-input-text user-input"
                  value={otpCode}
                  onInput={this.onOtpChange}
                  onKeyUp={this.onOtpKeyUp}
                  style={{
                    color: addToCartButton.color,
                    borderBottom: `2px solid ${addToCartButton.color}`
                  }}
                />
              </div>

              <div
                className="send-button-phone"
                style={{ ...addToCartButton, border: 'none' }}
                onClick={this.onOtpSubmit}
              >
                <SendButton fill={addToCartButton.textColor} height={26} width={26} />
              </div>
            </div>
          )}

          {(inputType === this.INPUT_TYPE.PHONE_ENTERED ||
            inputType === this.INPUT_TYPE.OTP_ENTERED) && <div className="loader" />}

          {error && <OTPError error={error} />}

          {inputType === this.INPUT_TYPE.OTP && (
            <div className="change-number">
              <div>
                <button
                  style={{
                    cursor: 'pointer',
                    color: themeTextColor,
                    border: 'none',
                    background: 'none'
                  }}
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    this.onChangeNumber();
                  }}
                >
                  {I18n.t('CHANGE_NUMBER')}
                </button>
              </div>
              <div>|</div>
              <div class="resend-otp">
                <div>{showOtpTimer ? `${I18n.t('RESEND_OTP')} in` : I18n.t('RECEIVE_OTP_VIA')}</div>{' '}
                {showOtpTimer ? (
                  <Timer
                    time={60}
                    onEnd={() => {
                      this.setState({
                        showOtpTimer: false
                      });
                    }}
                  />
                ) : (
                  <>
                    <button
                      class="resend-otp-button"
                      disabled={showOtpTimer}
                      onClick={() => {
                        this.onPhoneSubmit(OTP_TYPES.SMS.value, true);
                      }}
                    >
                      {' '}
                      <span>{OTP_TYPES.SMS.name}</span>{' '}
                    </button>
                    <div>
                      <span>{I18n.t('OR')}</span>
                      <button
                        class="resend-otp-button"
                        disabled={showOtpTimer}
                        onClick={() => {
                          this.setState({
                            showOtpTimer: true
                          });
                          this.onPhoneSubmit(OTP_TYPES.WHATSAPP.value, true);
                        }}
                      >
                        {' '}
                        <span>{OTP_TYPES.WHATSAPP.name}</span>
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
        <ReCAPTCHA sitekey={reCaptchaSiteKey} size="invisible" ref={this.recaptchaRef} />
      </div>
    );
  }
}

export default RequestIdentityChat;
